import React, { useState, useEffect } from "react";

function Carousel({ slides, interval = 5000 }) {
  const [current, setCurrent] = useState(0);
  const total = slides.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % total);
    }, interval);
    return () => clearInterval(timer);
  }, [total, interval]);

  return (
    <div className="carousel-container">
      <div
        className="carousel-track"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {slides.map((slide, i) => (
          <div className="carousel-slide" key={i}>
            {slide}
          </div>
        ))}
      </div>
      <div className="carousel-nav">
        <button
          className="carousel-btn"
          onClick={() => setCurrent((c) => (c - 1 + total) % total)}
        >
          &#x2039;
        </button>
        <button
          className="carousel-btn"
          onClick={() => setCurrent((c) => (c + 1) % total)}
        >
          &#x203A;
        </button>
      </div>
      <div className="carousel-indicators">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`indicator${i === current ? " active" : ""}`}
            onClick={() => setCurrent(i)}
          ></span>
        ))}
      </div>
    </div>
  );
}

export default Carousel;
